module.exports = __webpack_public_path__ + "img/icons/new/locked-pg-4f540556213728b352016dfc9dd4dbc1.svg";